import { Component, OnInit, ViewChild, HostListener } from '@angular/core';
import { UntypedFormGroup, FormControl, UntypedFormControl } from '@angular/forms';
import { GrantsSummaryService } from 'src/app/services/grants/grants-summary.service';
import { Subject, tap } from 'rxjs';
import { CommonService } from 'src/app/services/common.service';
import { UserService } from 'src/app/services/user.service';
import { ExtendedFormControlsComponent } from 'src/app/common/extended-form-controls/extended-form-controls.component';
import { GrantsDatashareService } from 'src/app/services/grants/grants-datashare.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HeadService } from 'src/app/services/common/headservice';
import * as $ from 'jquery';
import { DateObject, ModuleMenu, SCREEN_CONTROL, Document_Upload_File, ScreenResponseModel, SCREEN_RESPONSE } from 'src/app/models/common';
import { DatePipe } from '@angular/common';
import { IDeactivateComponent } from 'src/app/services/common/deactivate-guard.service';
import { FileService } from '../../../services/file.service';
import * as _ from 'lodash';
import { serviceConstants } from 'src/app/constants/service.constants';
@Component({
  selector: 'app-grants-general-information-sponsorship',
  templateUrl: './grants-general-information-sponsorship.component.html',
  styleUrls: ['./grants-general-information-sponsorship.component.scss']
})
export class GrantsGeneralInformationSponsorshipComponent implements OnInit , IDeactivateComponent {

  generalInformationForm: UntypedFormGroup;
  permission: string = "";
  staticformFields: any;
  action: Subject<any> = new Subject();
  userType: string = "";
  heading: string;
  operations: any = [];
  ApplicationID: any;
  menudata: ModuleMenu;
  ProgramStartDate: Date
  ProgramEndDate: Date
  minPStartDate : Date 
  maxPStartDate: Date | undefined;
  minPEndDate : Date 
  isStartDateModified: boolean = false;
  isEndDateModified: boolean = false;
  Full_Start_Date: DateObject;
  Full_End_Date: DateObject;
  Application_Type_ID: string="";
  

  /////new changes //////////
  IsRecordSaved: boolean = false;
  IsFormToched: boolean = false;
  isDateModified: boolean = false;
  Full_Date: DateObject;
  tooltipValue: any;
  SCREEN_MODEL: any = null;
  status : number = 0;
  ScreenName: string="";
  createdUser: any;
  disableSave: boolean = false;
  ScreenSubmitStatus: boolean = false;
  user : any
  Id : string;
  ModelData: any = null;
  isSubmitVisible : boolean = false;
  grantsApp: any;
  submittedresponse: SCREEN_RESPONSE[] = [];
  Currency_ID: string = '';

  constructor(
    public commonService: CommonService,
    private userService: UserService,
    private DatashareSerivce: GrantsDatashareService,
    private summaryService: GrantsSummaryService,
    public route: ActivatedRoute,
    private router: Router,
    private header: HeadService,
    private datepipe: DatePipe,
    private fileService: FileService
  ) {
    //this.setFormPermissions();
    this.Application_Type_ID = route.snapshot.queryParams['ApplicationType'];
  }

  @HostListener('input', ['$event'])
  onInputChange(event: any) {
    this.IsFormToched = true;
  }

  ngOnInit() {
    this.DatashareSerivce.GrantApplicationID.subscribe(x => {
      this.ApplicationID = x;
    });
    this.GetScreenConfigControls('GSP01');

    if (this.Application_Type_ID == null || this.Application_Type_ID == undefined || this.Application_Type_ID == "") {
      this.DatashareSerivce.Application_Type_ID.subscribe(x => {
        this.Application_Type_ID = x;
      });
    }
     if (this.Currency_ID == null || this.Currency_ID == undefined || this.Currency_ID == "") {
      this.DatashareSerivce.Currency_ID.subscribe(x => {
        this.Currency_ID = x;
      });
    }
    this.grantsApp = this.commonService.getGrantsApp();
    this.user = this.userService.getUserDetais();
    this.userType = this.userService.getUserType();

    if (!this.ApplicationID) {
      this.DatashareSerivce.setApplication_Type_ID(this.Application_Type_ID);
    }
    else {
      this.DatashareSerivce.setApplication_Type_ID("");
    }

    this.commonService.getGlobalDirtyInfo().subscribe((res) => {
      this.IsFormToched = false;
    });

    if(!this.isSubmitVisible){
      this.disableSave = false;
    }

    //this.getScreenDataEdit();

    this.permission = this.commonService.getPagePermission("GSP01").toLowerCase();
    if (this.permission == null || this.permission == undefined || this.permission == ''){
       const intervalId = setInterval(() => {
         this.permission = this.commonService.getPagePermission("GSP01").toLowerCase();
         if (this.permission != null && this.permission != undefined && this.permission != '') {
           clearInterval(intervalId);
            this.setFormPermissions();
         }
       }, 1000);
   }
   else{
    this.setFormPermissions();
   }

  }



  private setFormPermissions() {
    if (this.permission == "view") {
      this.operations = [];
    }
    else {
      this.operations = [
        { name: 'SaveGeneralInfo', type: 'submit', callback: this.SaveGeneralInfo, self: this }
      ]
    }

  }

 getStaticFiledsData(screenCode:string) {
  this.commonService.getScreenStaticFields(screenCode,this.ApplicationID)
    .subscribe(summary => {
      this.staticformFields = summary["Data"];
      
      // if(this.staticformFields?.PROGRAM_START_DATE?.IS_PASTDATES_ALLOWED)
      //  { this.minPStartDate = new Date(); this.minPStartDate.setHours(0,0,0,0) }
      // else this.minPStartDate = null;
      // if(this.staticformFields?.PROGRAM_END_DATE.IS_PASTDATES_ALLOWED)
      //  {  this.minPEndDate = new Date();  this.minPEndDate.setHours(0,0,0,0) }
      // else this.minPEndDate = null;
 
    });
}

onCallbackOperation(opr) {
  opr.callback(this.summaryService, this.generalInformationForm, this.DatashareSerivce);
}

CompareDates(olddate: any, newDate: any): boolean {
  if (olddate != '' && olddate != undefined && olddate != null) {

    let oDt = olddate.getDate().toString() + olddate.getMonth().toString() + olddate.getFullYear().toString();
    let nDt = newDate.getDate().toString() + newDate.getMonth().toString() + newDate.getFullYear().toString();
    if (oDt == nDt) { return true }
    else { return false }
  }
  else
    return false
}


startDateSelect(event) {
 // this.minPEndDate = event;
  this.isStartDateModified = true
  this.Full_Start_Date = {
    Day: event.getDate(),
    Month: (event.getMonth() + 1),
    Year: event.getFullYear(),
    Hours: 0,
    Minutes: 0,
    Seconds: 0,
    IsEndDate: false,
    HasValue: true,
    IsDateModified: this.isStartDateModified
  }
}

endDateSelect(event) {
 // this.maxPStartDate = event;
  this.isEndDateModified = true;
  this.Full_End_Date = {
    Day: event.getDate(),
    Month: (event.getMonth() + 1),
    Year: event.getFullYear(),
    Hours: 23,
    Minutes: 59,
    Seconds: 59,
    IsEndDate: true,
    HasValue: true,
    IsDateModified: this.isEndDateModified
  }
}

GetStartDate(): DateObject {
  var formModel = this.generalInformationForm.getRawValue();
  const lDate = new Date(formModel.PROGRAM_START_DATE);
  if ((this.CompareDates(this.ProgramStartDate, lDate) || this.Full_Start_Date == null || this.Full_Start_Date == undefined) && formModel.PROGRAM_START_DATE != null) {
    this.Full_Start_Date = {
      Day: lDate.getDate(),
      Month: lDate.getMonth() + 1,
      Year: lDate.getFullYear(),
      Hours: 0,
      Minutes: 0,
      Seconds: 0,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: false
    }
  }
  else{
    this.Full_Start_Date = {
      Day: lDate.getDate(),
      Month: lDate.getMonth() + 1,
      Year: lDate.getFullYear(),
      Hours: 0,
      Minutes: 0,
      Seconds: 0,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: true
    }
  }
  return this.Full_Start_Date
}

GetEndDate(): DateObject {
  const formModel = this.generalInformationForm.getRawValue();
  const lDate = new Date(formModel.PROGRAM_END_DATE);
  if ((this.CompareDates(this.ProgramEndDate, lDate) || this.Full_End_Date == null || this.Full_End_Date == undefined) && formModel.PROGRAM_END_DATE != null)
    this.Full_End_Date = {
      Day: lDate.getDate(),
      Month: lDate.getMonth() + 1,
      Year: lDate.getFullYear(),
      Hours: 23,
      Minutes: 59,
      Seconds: 59,
      IsEndDate: true,
      HasValue: true,
      IsDateModified: false
    }
    else{
      this.Full_End_Date = {
        Day: lDate.getDate(),
        Month: lDate.getMonth() + 1,
        Year: lDate.getFullYear(),
        Hours: 23,
        Minutes: 59,
        Seconds: 59,
        IsEndDate: true,
        HasValue: true,
        IsDateModified: true
      }
    }
  return this.Full_End_Date;
}


SaveGeneralInfo(SaveType : string) {

  if(this.IsRecordSaved && this.user.ID != this.createdUser && this.ScreenSubmitStatus==false){   
    return this.commonService.ValidationBanner("This screen is currently being worked on by another user. You are not permitted to make changes at this time.");
   }

  if (this.validateControls()) {
    if (this.staticformFields != null && this.staticformFields.length > 0) {
      for (let i = 0; i < this.staticformFields.length; i++) {
        switch (this.staticformFields[i].CONTROL) {
          case 6:
            let seletedItem = "";
            for (let c = 0; c < this.staticformFields[i].SourceItems.length; c++) {
              if (this.staticformFields[i].SourceItems[c].Checked == true) {
                if (seletedItem == "")
                  seletedItem = this.staticformFields[i].SourceItems[c].value;
                else
                  seletedItem = seletedItem + "," + this.staticformFields[i].SourceItems[c].value;
              }
            }
            this.staticformFields[i].ANSWER = seletedItem;
            break;
          case 8:
            this.staticformFields[i].UploadedDocuments = [];
            if (this.staticformFields[i].UploadFiles) {
              for (let j = 0; j < this.staticformFields[i].UploadFiles.length; j++) {
                if (this.staticformFields[i].UploadFiles[j].Status == "Add" || this.staticformFields[i].UploadFiles[j].Status == "Delete") {
                  this.staticformFields[i].UploadedDocuments.push(this.staticformFields[i].UploadFiles[j]);
                }
              }
              this.staticformFields[i].ANSWER = null;
              this.staticformFields[i].ControlValue = null;
            }
            break;
          case 10:
            let SelectedValues = this.staticformFields[i].ControlValue;
            if (SelectedValues != null && SelectedValues != undefined && SelectedValues.length > 0) {
              this.staticformFields[i].ANSWER = SelectedValues.join(",");
            }
            else {
              this.staticformFields[i].ANSWER = "";
            }
            this.staticformFields[i].SUBFIELDNAME = "";
           // this.staticformFields[i].ControlValue = null;
            break;
          case 5:
            let controlanswer = this.staticformFields[i].ControlValue;
            if (controlanswer != null && controlanswer != "" && controlanswer != undefined) {
                let formd = this.datepipe.transform(new Date(controlanswer), 'dd-MMM-yyyy');
                this.staticformFields[i].ANSWER = formd;
              }
                else {
                  this.staticformFields[i].ANSWER = controlanswer;
            }
            break;
          default:
            this.staticformFields[i].ANSWER = this.staticformFields[i].ControlValue;
            break;
        }
      }
      let uploadData = new FormData();

     let FinalControls=_.cloneDeep(this.staticformFields);
          FinalControls.forEach((item)=>{
            switch (item.CONTROL) {
              case 10:
                item.ControlValue=null;
                break;
            }
      });
      uploadData.append("ScreenControlsData", JSON.stringify(FinalControls));
      uploadData.append("Appid", this.ApplicationID);
      uploadData.append("ModuleID", "4");
      uploadData.append("Is_fromGeneralInformation", "yes");

      if (SaveType == "Save") {
        if(this.isSubmitVisible == true && this.grantsApp?.STATUS > 1 && this.ScreenSubmitStatus == false) {
          uploadData.append("SUBMIT_STATUS", "0");
        } 
        else {
          uploadData.append("SUBMIT_STATUS", "1");
        }
      } else{
        uploadData.append("SUBMIT_STATUS", "1");
      }

      if (this.ApplicationID == "" || this.ApplicationID == undefined) {
        uploadData.append("Application_Type_ID", this.Application_Type_ID);
uploadData.append("Currency_ID", this.Currency_ID);
        this.summaryService.SaveCMEGeneralInfo("api/GMAPPSponsorship/Insert", uploadData).subscribe((result) => {
          this.IsFormToched = false;
          this.ApplicationID = result["TransactionID"];
          this.DatashareSerivce.setGrantApplicationID(this.ApplicationID);
          if (result.Status === 0) {
            this.getScreenDataEdit();
            this.commonService.SuccessBanner(this.ScreenName + " saved successfully");
            this.commonService.refreshApplicationPage(this.ApplicationID,'grants');
          }
          else {
            this.commonService.ValidationBanner(result.Message);
          }
        });
      }
      else {
        this.summaryService.SaveCMEGeneralInfo("api/GMAPPSponsorship/Update", uploadData).subscribe((result) => {
          this.IsFormToched = false;
          if (result.Status === 0) {
            if (result.ErrorCode === "NOCHANGES") {
              this.getScreenDataEdit();
              this.commonService.ValidationBanner(result.Message);
            }
            else {
              this.getScreenDataEdit();
              this.commonService.SuccessBanner(this.ScreenName + " saved successfully");
            }
          }
          else {
            this.getScreenDataEdit();
            this.commonService.ValidationBanner(result.Message);
          }
        });
      
      }
    }
  }
}

refreshPage(idAPP: any,PKID:any) {
  this.summaryService.getCMEApplicationSummary("api/common/getgrantsapp/" + idAPP).subscribe(data => {
    this.commonService.appId = idAPP;
    this.commonService.ScreenID = PKID;
    this.commonService.setGrantsApp(data);
    this.menudata = new ModuleMenu();
    this.menudata.module = "GRANTSSPONSORSHIP";
    this.menudata.operation = "Edit";
    this.menudata.appId = idAPP;
    this.menudata.screenID=PKID;
    this.menudata.formstate = "Draft";
    this.commonService.setModluleMenu(this.menudata);
    this.DatashareSerivce.setGrantApplicationID(idAPP);
    this.header.setHeader(this.menudata);
    this.generalInformationForm.patchValue({
      ID: PKID});
      this.router.navigate(['/home/grants/my-applications/application-ext/:'+idAPP+'/'+data.StartMenu], { skipLocationChange: true, queryParams: { module: "grants",submodule:this.menudata.module , id: PKID, app_ext: true, screen_type: "my-applications" }
    });

  });
  this.generalInformationForm.markAsPristine();
}

redirectTo(uri: string) {
  this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
    this.router.navigate([uri]));
}


canExit() {
  if (this.IsFormToched) {
    return this.commonService.CanDeactivateBanner();
  }
  else {
    return Promise.resolve(true);
  }
}



/// new changes/////

singleonChange($event, question) {
  this.IsFormToched = true;
  this.UpdateParentChildDetails(question);
  this.ApplyConditions($event, question, "Y");
  }

UpdateParentChildDetails(question: any) {
  if (question.Control_Condtions == null || question.Control_Condtions == undefined) {
    question.Control_Condtions = [];
  }
  let displayControlIDS = [];
  let hideControlIDS = [];
  let enableControlIDS = [];
  let disbledControlIDS = [];

  question.Control_Condtions.forEach((item) => {
    item.ConditionsList.forEach((otemCon) => {
      switch (otemCon.Mapped_Condtion) {
        case "1": //display
          if (displayControlIDS.length == 0) {
            displayControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
          }
          else {
            let disCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            if (disCntrIds && disCntrIds.length > 0) {
              disCntrIds.forEach((id) => {
                if (!displayControlIDS.includes(id)) {
                  displayControlIDS.push(id);
                }
              })
            }
          }

          break;
        case "2": //enabled

          if (enableControlIDS.length == 0) {
            enableControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
          }
          else {
            let enableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            if (enableCntrIds && enableCntrIds.length > 0) {
              enableCntrIds.forEach((id) => {
                if (!enableControlIDS.includes(id)) {
                  enableControlIDS.push(id);
                }
              })
            }
          }
          break;
        case "3": //hide

          if (hideControlIDS.length == 0) {
            hideControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
          }
          else {
            let hideCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            if (hideCntrIds && hideCntrIds.length > 0) {
              hideCntrIds.forEach((id) => {
                if (!hideControlIDS.includes(id)) {
                  hideControlIDS.push(id);
                }
              })
            }
          }
          break;

        case "4": //disabled
          if (disbledControlIDS.length == 0) {
            disbledControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
          }
          else {
            let disableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            if (disableCntrIds && disableCntrIds.length > 0) {
              disableCntrIds.forEach((id) => {
                if (!disbledControlIDS.includes(id)) {
                  disbledControlIDS.push(id);
                }
              })
            }
          }
          break;
      }
    });
  })

  this.staticformFields.forEach((con) => {
    if (displayControlIDS.indexOf(con.ID) > -1) {
      con.IS_Dependent_Display = false;
    }
    if (hideControlIDS.indexOf(con.ID) > -1) {
      con.IS_Dependent_Display = true;
    }
    if (enableControlIDS.indexOf(con.ID) > -1) {
      con.IS_Dependent_Enabled = false;
    }
    if (disbledControlIDS.indexOf(con.ID) > -1) {
      con.IS_Dependent_Enabled = true;
    }
  });

}
ApplyConditions($event, question, makeNull) {
  let value = $event.value;
  if (question.Control_Condtions == null || question.Control_Condtions == undefined) {
    question.Control_Condtions = [];
  }
  let displayControlIDS = [];
  let hideControlIDS = [];
  let enableControlIDS = [];
  let disbledControlIDS = [];

  question.Control_Condtions.forEach((item) => {
    if (item.Mapped_Control_Value == value) {
      item.ConditionsList.forEach((otemCon) => {
        switch (otemCon.Mapped_Condtion) {
          case "1": //display
            if (displayControlIDS.length == 0) {
              displayControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let disCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (disCntrIds && disCntrIds.length > 0) {
                disCntrIds.forEach((id) => {
                  if (!displayControlIDS.includes(id)) {
                    displayControlIDS.push(id);
                  }
                })
              }
            }

            break;
          case "2": //enabled
            if (enableControlIDS.length == 0) {
              enableControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let enableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (enableCntrIds && enableCntrIds.length > 0) {
                enableCntrIds.forEach((id) => {
                  if (!enableControlIDS.includes(id)) {
                    enableControlIDS.push(id);
                  }
                })
              }
            }
            break;
          case "3": //hide
            if (hideControlIDS.length == 0) {
              hideControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let hideCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (hideCntrIds && hideCntrIds.length > 0) {
                hideCntrIds.forEach((id) => {
                  if (!hideControlIDS.includes(id)) {
                    hideControlIDS.push(id);
                  }
                })
              }
            }

            break;

          case "4": //disabled
            if (disbledControlIDS.length == 0) {
              disbledControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let disableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (disableCntrIds && disableCntrIds.length > 0) {
                disableCntrIds.forEach((id) => {
                  if (!disbledControlIDS.includes(id)) {
                    disbledControlIDS.push(id);
                  }
                })
              }
            }
            break;
        }

      });
    }
  })
  //default
  if (value != "") {
    this.staticformFields.forEach((con) => {

      if (displayControlIDS.indexOf(con.ID) > -1) {
        con.IS_Dependent_Display = true;
        if (con.CONTROL == "4")
          this.UpdateParentChildDetails(con);
      }
      if (hideControlIDS.indexOf(con.ID) > -1) {
        con.IS_Dependent_Display = false;
        if (con.CONTROL == "4")
          this.UpdateParentChildDetails(con);
      }
      if (enableControlIDS.indexOf(con.ID) > -1) {
        con.IS_Dependent_Enabled = true;
        if (con.CONTROL == "4")
          this.UpdateParentChildDetails(con);
      }
      if (disbledControlIDS.indexOf(con.ID) > -1) {
        con.IS_Dependent_Enabled = false;
        if (con.CONTROL == "4")
          this.UpdateParentChildDetails(con);
      }

    });
  }
  else {
    this.UpdateParentChildDetails(question);
  }

  if (makeNull == "Y") {
    this.staticformFields.forEach((con) => {
      if (con.IS_Dependent_Display==false) {
        con.ControlValue = "";
        if (con.CONTROL == "10") {
          con.ControlValue = [];
        }
        if (con.CONTROL == "8") {
          con.UploadFiles.forEach((item) => {
            item.Status = "Delete";
          });
        }
        if(con.CONTROL == "6"){
          con.SourceItems.forEach((item) => {
            item.Checked = false;
          });
        }
      }
      if (con.IS_Dependent_Display==true) {
        
      }
      if (con.IS_Dependent_Enabled == false) {
        con.ControlValue = "";
        if (con.CONTROL == "10") {
          con.ControlValue = [];
        }
        if (con.CONTROL == "8") {
          con.UploadFiles.forEach((item) => {
            item.Status = "Delete";
          });
        }
        if(con.CONTROL == "6")
          {
            con.SourceItems.forEach((item) => {
              item.Checked = false;
            });
          }
      }
      if (con.IS_Dependent_Enabled == true) {
       
      }
    });
  }
}
DateSelect(event, question) {
  this.IsFormToched = true;
  this.isDateModified = true;
  this.Full_Date = {
    Day: event.getDate(),
    Month: (event.getMonth() + 1),
    Year: event.getFullYear(),
    Hours: 0,
    Minutes: 0,
    Seconds: 0,
    IsEndDate: false,
    HasValue: true,
    IsDateModified: this.isDateModified
  }
  question.dynamicDateobj = this.Full_Date;
}
ViewFile(fileID, fileName) {
  this.commonService.previewFile(fileID, fileName, "med");
}
isAllowedExtensionFile(Filename) {
  return this.commonService.isAllowedExtension(Filename);
}
saveTempFiles(selectedFiles: any) {
  const formData = new FormData();
  formData.append(`files`, selectedFiles);
  return this.fileService.uploadMultiFiles(formData, "");
}

changeVal($event, question) {
  question.NotimesChanged = question.NotimesChanged + 1;
  question.IsTouched = true;
  if (question.NotimesChanged >= 2)
    this.IsFormToched = true;

  setTimeout(() => {
    let selectedControl = question.ControlValue;
    if (selectedControl != "" && selectedControl != undefined && selectedControl != null) {
      let controlLabel = question.SourceItems.filter((item) => {
        return selectedControl.indexOf(item.value) > -1;
      })
      let labellist = [];
      controlLabel.forEach((item) => {
        labellist.push(item.label);
      });
      this.tooltipValue = labellist.join(",");
    }
    else {
      this.tooltipValue = "";
    }

  }, 200);

}
uploadchange(event, ques: SCREEN_CONTROL): void {
  //let Flag = true;
  let Isexe = false;
  let Is5oMB = false;
  if (ques.UploadFiles == undefined || ques.UploadFiles == null)
    ques.UploadFiles = [];
  for (let i = 0; i < event.target.files.length; i++) {
    let uploadFile = new Document_Upload_File();
    let file = event.target.files[i].name;
    let ext = file.match(/\.([^\.]+)$/)[1];
    let filesize = event.target.files[i].size;

    // if (file != null && ((filesize > 52428800) || (ext == 'exe'))) {
    //   Flag = false;
    // }
    
    if (file != null && (ext == 'exe')) {
          Isexe = true;
        }
        else if (file != null && ((filesize > 52428800))) {
          Is5oMB = true;
    }

    else {
      this.saveTempFiles(event.target.files[i]).subscribe((result: any) => {
        let uploadFile = new Document_Upload_File();
        uploadFile.ID = result.Data[0].FileID;
        uploadFile.DOCUMENT_NAME = event.target.files[i].name;
        uploadFile.File = null;
        uploadFile.Status = "Add";
        uploadFile.UploadedDate = this.datepipe.transform(new Date().toUTCString(), 'dd-MMM-YYYY');
        let hasValue = ques.UploadFiles.filter(x => x.DOCUMENT_NAME.toLowerCase() == uploadFile.DOCUMENT_NAME.toLowerCase() && x.Status != "Delete");
        if (hasValue.length > 0) {
          this.commonService.ValidationBanner("File already exists with " + uploadFile.DOCUMENT_NAME + " Please update the unique file name");
        }
        else if (ques.ISALLOWMULTIPLEFILES) {
          ques.UploadFiles.push(uploadFile);
        } else {
          ques.UploadFiles.forEach((item) => {
            item.Status = "Delete";
          })
          ques.UploadFiles.push(uploadFile);
        }
      });

    }
  }
  // if (!Flag)
  //   this.commonService.ValidationBanner("Please upload files with Word, PPT, Excel, Pdf, Text formats only with maximum size of 50MB");

  if (Is5oMB && Isexe) {
      this.commonService.ValidationBanner("The system does not support .exe files. Please choose a different file format to save the details and Accepts maximum file size 50MB");
    }

    else if (Is5oMB) {
      this.commonService.ValidationBanner("Accepts maximum file size 50MB");
    }

    else if (Isexe) {
      this.commonService.ValidationBanner("The system does not support .exe files. Please choose a different file format to save the details")
    }
}

GetScreenConfigControls(screenCode: string) {
  this.commonService.GetScreenConfigControls(screenCode, this.ApplicationID, this.ApplicationID,(ScreenData) => {
    this.SCREEN_MODEL = ScreenData;
    this.ScreenName = this.SCREEN_MODEL?.NAME;
    this.staticformFields = ScreenData["SCREEN_CONTROL"];
    this.getScreenDataEdit();
    if(this.grantsApp?.STATUS > 1 ){
      this.isSubmitVisible = ScreenData.HAS_SAVE_SUBMIT == 1 ? true :false;       
    }     
  });
}

getScreenDataEdit() {
  this.summaryService.getGeneralInformationCME("api/GMAPPSponsorship/GetMasterList?ApplicationID=" + this.ApplicationID).subscribe((summary) => {
    if (summary != null && summary != undefined) {        
      this.createdUser = summary["RECORD_CREATED_BY"];
      this.status = summary["STATUS"];
      if(summary["RECORD_CREATED_BY"] == null){
        this.IsRecordSaved = false;
      }
      else{
        this.IsRecordSaved = true;
      }
      
      if(((this.user.ID != summary["RECORD_CREATED_BY"]) && summary["SUBMIT_STATUS"] == 1 ) || (this.user.ID == summary["RECORD_CREATED_BY"]) || this.isSubmitVisible == false ){
        this.Id = summary["ID"];
       
        this.ModelData = summary;
        this.setFormPermissions();
        this.BindDataToDynamicControls();
        this.BindDataToStaticControls(summary);
        this.ScreenSubmitStatus = summary["SUBMIT_STATUS"] == 1 ? true : false;
      } 
      
      if(summary["SUBMIT_STATUS"] == 1){
        this.disableSave = true;
      }
      else{
         this.disableSave = false;
      }

      if(!this.isSubmitVisible){
        this.disableSave = false;
      }
    }
  });
}

BindDataToDynamicControls() {
  if (this.ApplicationID != null && this.ApplicationID != undefined && this.ApplicationID != "") {
    let sr = new ScreenResponseModel();
    sr.Id = "GSP01";
    sr.RowId = this.ApplicationID;
    sr.AppId = this.ApplicationID;
    this.summaryService.getScreenResponse(sr).subscribe(summary => {
      this.submittedresponse = summary;
      if (this.submittedresponse != null && this.submittedresponse.length > 0) {
        for (let i = 0; i < this.staticformFields.length; i++) {
          var response = this.submittedresponse.filter(x => x.SCREEN_CONTROL_ID == this.staticformFields[i].ID);

          if (response != null && response.length > 0) {
            if (this.staticformFields[i].CONTROL == '6') {
              if (response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != null && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != undefined && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != "") {
                this.staticformFields[i].ControlValue = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER;
                var options = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER.split(",");
                if (this.staticformFields[i].SourceItems != null && this.staticformFields[i].SourceItems != undefined) {
                  for (let c = 0; c < this.staticformFields[i].SourceItems.length; c++) {
                    if (options.indexOf(this.staticformFields[i].SourceItems[c].value) > -1) {
                      this.staticformFields[i].SourceItems[c].Checked = true;
                    }
                    else {
                      this.staticformFields[i].SourceItems[c].Checked = false;
                    }
                  }
                }

              }
            }
            else if (this.staticformFields[i].CONTROL == '10') {
              this.staticformFields[i].NotimesChanged = 0;
              if (response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != null && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != undefined && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != "") {
                this.staticformFields[i].ControlValue = [];

                var options1 = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER.split(',');
                options1.forEach((item) => {
                  this.staticformFields[i].ControlValue.push(item);
                });
                this.staticformFields[i].SUBFIELDNAME = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER;
              }
              else {
                this.staticformFields[i].ControlValue = [];
              }
            }
            else if (this.staticformFields[i].CONTROL == '5') {
              if (response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != null && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != "" && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != undefined) {
                let formd = new Date(response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER);
                this.staticformFields[i].ControlValue = formd;

                if (this.staticformFields[i].DATEFORMATE == 'DD-MMM-YYYY') {
                  let formd = this.commonService.getdisplayedDate(response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER);
                  this.staticformFields[i].ControlValue = formd;
                }

              }

            }
            else {
              this.staticformFields[i].ControlValue = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER;
            }
            this.staticformFields[i].UploadFiles = response[0].UploadFiles;
            if (this.staticformFields[i].CONTROL == '4') {
              this.ApplyConditions({ value: this.staticformFields[i].ControlValue }, this.staticformFields[i], "N");
            }
          }

        }
      }

    });
  }
}

BindDataToStaticControls(MainObjData: any): any {
  for (var i = 0; i < this.staticformFields.length; i++) {
    switch (this.staticformFields[i].FIELD_CODE) {
      case "THERAPEUTIC_AREA_ID":
        this.staticformFields[i].ControlValue = MainObjData.THERAPEUTIC_AREA_ID;
        break;
      case "PROGRAM_TITLE":
        this.staticformFields[i].ControlValue = MainObjData.PROGRAM_TITLE;
        break;
      case "IS_HP_ATTENDING":
        this.staticformFields[i].ControlValue = MainObjData.IS_HP_ATTENDING;
        break;
      case "SPONSERSHIP_LEVEL":
        this.staticformFields[i].ControlValue = MainObjData.SPONSERSHIP_LEVEL;
        break;
      case "IS_OTH_SPONSERSHIP":
        this.staticformFields[i].ControlValue = MainObjData.IS_OTH_SPONSERSHIP;
        break;
      case "PROGRAM_START_DATE":
        if(MainObjData.PROGRAM_START_DATE != null)
        {
          this.staticformFields[i].ControlValue = new Date(MainObjData.PROGRAM_START_DATE);
        }
        else
        {
          this.staticformFields[i].ControlValue = null;
        }
        break;
      case "PROGRAM_END_DATE":
        if(MainObjData.PROGRAM_END_DATE != null)
        {
          this.staticformFields[i].ControlValue = new Date(MainObjData.PROGRAM_END_DATE);
        }
        else
        {
          this.staticformFields[i].ControlValue = null;
        }
        break;
      case "REQUEST_AMOUNT":
        this.staticformFields[i].ControlValue = MainObjData.REQUEST_AMOUNT;
        break;
      case "TOTAL_BUDGET":
        this.staticformFields[i].ControlValue = MainObjData.TOTAL_BUDGET;
        break;
      case "TAX_DEDUCTED":
        this.staticformFields[i].ControlValue = MainObjData.TAX_DEDUCTED;
        break;
      case "IS_OTH_FIN_SUPPORT":
        this.staticformFields[i].ControlValue = MainObjData.IS_OTH_FIN_SUPPORT;
        break;
      case "ANNUAL_BUDGET_PERCENTAGE":
        this.staticformFields[i].ControlValue = MainObjData.ANNUAL_BUDGET_PERCENTAGE;
        break;
      case "IS_USED_POLITICAL":
        this.staticformFields[i].ControlValue = MainObjData.IS_USED_POLITICAL;
        break;
      case "IS_USED_COPAYMENTS":
        this.staticformFields[i].ControlValue = MainObjData.IS_USED_COPAYMENTS;
        break;
      case "IS_USED_OTH_ACTIVITY":
        this.staticformFields[i].ControlValue = MainObjData.IS_USED_OTH_ACTIVITY;
        break;
      case "IS_USED_MEALS":
        this.staticformFields[i].ControlValue = MainObjData.IS_USED_MEALS;
        break;
      case "IS_ACCREDITED_SPONSORED":
        this.staticformFields[i].ControlValue = MainObjData.IS_ACCREDITED_SPONSORED;
        break;
      case "IS_HELD_PROGRAM":
        this.staticformFields[i].ControlValue = MainObjData.IS_HELD_PROGRAM;
        break;
      case "DETAILED_PURPOSE":
        this.staticformFields[i].ControlValue = MainObjData.DETAILED_PURPOSE;
        break;
      case "IS_PRE_SUPPORTED":
        this.staticformFields[i].ControlValue = MainObjData.IS_PRE_SUPPORTED;
        break;
      case "APPLICATION_TITLE":
        this.staticformFields[i].ControlValue = MainObjData.APPLICATION_TITLE;
        break;
    }

    if (this.staticformFields[i].CONTROL == '4') {
      this.ApplyConditions({ value: this.staticformFields[i].ControlValue }, this.staticformFields[i], "N");
    }
  }

}

validateControls(): boolean {
  let isValid = true;
  let message = "";
  if(this.grantsApp?.STATUS >= 2){
    this.staticformFields.forEach((item) => {
      if (item.IS_MANDATORY && item.IS_Dependent_Enabled == true && item.IS_Dependent_Display == true) {
        switch (item.CONTROL) {
          case 1:
          case 2:
          case 3:
          case 5:
          case 4:
          case 11:
            if (!item.ControlValue) {
              $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
              $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
              message += `Please enter ${item.LABEL} <br/>`;
              isValid = false;
            }
            break;
          case 10:
              if (!(item.ControlValue) || (item.ControlValue != null && item.ControlValue.length == 0)) {
                $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
                $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
                message += `Please enter ${item.LABEL} <br/>`;
                isValid = false;
              }
            break;
          case 6:
            let seletedItem = "";
            for (let c = 0; c < item.SourceItems.length; c++) {
              if (item.SourceItems[c].Checked == true) {
                if (seletedItem == "")
                  seletedItem = item.SourceItems[c].value;
                else
                  seletedItem = seletedItem + "," + item.SourceItems[c].value;
              }
            }
            item.ControlValue = seletedItem;
            if(!item.ControlValue)
            {
              $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
              $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
              message += `Please enter ${item.LABEL} <br/>`;
              isValid = false;
            }
            break;
          
          case 7:
            if (!item.ControlValue) {
              $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
              $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
              message += `Please enter ${item.LABEL} <br/>`;
              isValid = false;
            }
            break;
          case 8:
            if (item.UploadFiles != null && item.UploadFiles != undefined && item.UploadFiles.length == 0) {
              $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
              $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
              message += `Please enter ${item.LABEL} <br/>`;
              isValid = false;
            }
            break;
          case 9:
            break;
        }
      }
    });

    if (isValid) {
      let inactiveValueControls = this.commonService.checkInactiveRecordState(this.staticformFields);
      if (inactiveValueControls && inactiveValueControls.length > 0) {
        isValid = false;
        let dataMsg = inactiveValueControls.join("</br>");
        this.commonService.ValidationBanner(dataMsg);
      }
    }
  }
  else {
    // Check at least one field value exists
    isValid = this.commonService.checkHasSingleControlValue(this.staticformFields);
    if (!isValid) {
      message += `Please enter at least one field. <br/>`;
    }
  }

    if (!isValid)
      this.commonService.ValidationBanner(message);
  return isValid;

  }

  DeleteUpload(file, ques: SCREEN_CONTROL): void {
      this.IsFormToched = true;
      let code = file.ID;
      if (file.Status == "Add") {
        ques.UploadFiles = ques.UploadFiles.filter(function (sec) {
          return sec.ID != code;
        }, code);
      }
      else {
        this.commonService.CheckIsFileIsRefereancedInReviw(code).subscribe((x) => {
          if (x["Status"] == 2 && x["Data"] == false) {
            this.commonService.ValidationBanner(x["Message"]);
          }
          else {
            file.Status = "Delete";
          }
        });
      }
    }
  
    OpenFile(item: Document_Upload_File): void {
      if (item.Status == "Edit") {
        let Url = serviceConstants.apiURL + "api/screen/downloadfile/" + item.ID;
        window.open(Url);
      }
    }

}
